<script>
    import {loadScript} from "@paypal/paypal-js"; // The library you just installed
    import {untrack} from 'svelte';

    /**
     * PROPS: These are the functions and values the parent
     * component will pass down to us.
     */
    let {
        // The public Client ID you get from Oxid/PayPal
        data,
        // A function passed from the parent to create the order on your backend
        createOrder,
        // A function passed from the parent to capture the order on your backend
        approveOrder
    } = $props();

    // Wir lesen `data` einmalig beim Mount. Re-Mount via key={} wenn Parent
    // das Objekt austauschen will. untrack() unterdrückt die
    // state_referenced_locally-Warnung — die Props sind absichtlich
    // mount-time-only.
    const {scriptConfig, buttonConfig} = untrack(() => data);

    let isLoading = $state(true);
    let errorMessage = $state(null);
    let paypalContainer = $state(); // bind:this DOM-reference

    // $effect runs after the component is mounted, replacing onMount.
    $effect(() => {
        const initPayPal = async () => {
            try {
                // 1. Asynchronously load the PayPal SDK script
                const paypal = await loadScript(scriptConfig);

                isLoading = false;

                // 2. Render the buttons
                await paypal.Buttons({
                    ...buttonConfig,
                    // 3. Call the `createOrder` prop (the function from the parent)
                    createOrder: async (data, actions) => {
                        errorMessage = null; // Clear old errors
                        try {
                            // This calls your PHP backend via the parent's function
                            return await createOrder(data, actions);
                        } catch (err) {
                            errorMessage = "Could not create the order. Please try again.";
                            return null;
                        }
                    },
                    // 4. Call the `onApprove` prop (the function from the parent)
                    onApprove: async (data, actions) => {
                        try {
                            console.log(data, actions)
                            // This calls your PHP backend via the parent's function
                            await approveOrder(data, actions);
                        } catch (err) {
                            errorMessage = "Payment capture failed. Please contact support.";
                            console.log(err);
                        }
                    },
                    onError: (err) => {
                        errorMessage = "An unknown PayPal error occurred. Please try again.";
                        console.error("PayPal onError:", err);
                    }
                }).render(paypalContainer); // 5. Mount the buttons to our div
            } catch (error) {
                console.error("Failed to load PayPal SDK:", error);
                errorMessage = "Failed to load PayPal. Please refresh the page.";
            }
        };
        initPayPal();
    });
</script>

<div>
    <div class="paypal-buttons-container w-full" bind:this={paypalContainer}>
        {#if isLoading}
            <div class="spinner"></div>
        {/if}
    </div>

    {#if errorMessage}
        <div class="payment-error-message">
            {errorMessage}
        </div>
    {/if}
</div>